var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.layout === 'main-layout')?_c('MainLayout',{attrs:{"id":"app"}}):_c('EmptyLayout')}
var staticRenderFns = []

export { render, staticRenderFns }